import { useEffect, useState } from "react";
import { IconDeviceMobile } from "@tabler/icons-react";
import { Button, Group, Input, Paper, Stack, Text } from "@/components/ui";
import { useActualizarCelular } from "../hooks/use-perfil-notificaciones";

const E164 = /^\+[1-9]\d{7,14}$/;

/** Celular E.164 (PhoneNumber de Identity) · destino de SMS y WhatsApp. */
export function CardCelular({ celular }: { celular: string | null }) {
  const [valor, setValor] = useState(celular ?? "");
  const guardar = useActualizarCelular();
  useEffect(() => setValor(celular ?? ""), [celular]);

  const normalizado = valor.replace(/[\s\-()]/g, "");
  const invalido = normalizado.length > 0 && !E164.test(normalizado);
  const sinCambios = normalizado === (celular ?? "");

  return (
    <Paper withBorder padding="lg">
      <Stack gap="sm">
        <Group gap="xs">
          <IconDeviceMobile size={18} className="text-multiva-600" />
          <Text fw={600}>Celular</Text>
        </Group>
        <Text size="sm" c="dimmed">Para recibir notificaciones por SMS y WhatsApp. Usa el formato internacional con lada del país.</Text>
        <form
          className="flex flex-wrap items-start gap-2"
          onSubmit={(e) => {
            e.preventDefault();
            if (!invalido) guardar.mutate(normalizado || null);
          }}
        >
          <Input
            type="tel"
            placeholder="+525512345678"
            value={valor}
            onChange={(e) => setValor(e.target.value)}
            error={invalido ? "Formato +52 seguido de 10 dígitos (E.164)" : undefined}
            wrapperClassName="w-64"
          />
          <Button type="submit" variant="outline" disabled={invalido || sinCambios} loading={guardar.isPending}>
            {normalizado ? "Guardar" : "Quitar celular"}
          </Button>
        </form>
      </Stack>
    </Paper>
  );
}
